import BeerIcon from "@lucide/svelte/icons/beer";
import BinocularsIcon from "@lucide/svelte/icons/binoculars";
import BriefcaseBusinessIcon from "@lucide/svelte/icons/briefcase-business";
import Building2Icon from "@lucide/svelte/icons/building-2";
import BusFrontIcon from "@lucide/svelte/icons/bus-front";
import CastleIcon from "@lucide/svelte/icons/castle";
import CoffeeIcon from "@lucide/svelte/icons/coffee";
import CroissantIcon from "@lucide/svelte/icons/croissant";
import DropletIcon from "@lucide/svelte/icons/droplet";
import DumbbellIcon from "@lucide/svelte/icons/dumbbell";
import GraduationCapIcon from "@lucide/svelte/icons/graduation-cap";
import HamburgerIcon from "@lucide/svelte/icons/hamburger";
import HospitalIcon from "@lucide/svelte/icons/hospital";
import HotelIcon from "@lucide/svelte/icons/hotel";
import IceCreamConeIcon from "@lucide/svelte/icons/ice-cream-cone";
import LandmarkIcon from "@lucide/svelte/icons/landmark";
import LibraryBigIcon from "@lucide/svelte/icons/library-big";
import PillIcon from "@lucide/svelte/icons/pill";
import SearchIcon from "@lucide/svelte/icons/search";
import ScissorsIcon from "@lucide/svelte/icons/scissors";
import ShirtIcon from "@lucide/svelte/icons/shirt";
import ShoppingBasketIcon from "@lucide/svelte/icons/shopping-basket";
import ShoppingCartIcon from "@lucide/svelte/icons/shopping-cart";
import StethoscopeIcon from "@lucide/svelte/icons/stethoscope";
import SquareIcon from "@lucide/svelte/icons/square";
import TrainFrontIcon from "@lucide/svelte/icons/train-front";
import TreesIcon from "@lucide/svelte/icons/trees";
import UtensilsIcon from "@lucide/svelte/icons/utensils";

// Keep the supported search icons explicit and shared between the data model
// and the Svelte renderer. This duplicates a small amount of Lucide import
// boilerplate, but it gives us compile-time checking that icon names are
// renderable without falling back to a broad package-wide export type.
export const SEARCH_ICONS = {
  Beer: BeerIcon,
  Binoculars: BinocularsIcon,
  BriefcaseBusiness: BriefcaseBusinessIcon,
  Building2: Building2Icon,
  BusFront: BusFrontIcon,
  Castle: CastleIcon,
  Coffee: CoffeeIcon,
  Croissant: CroissantIcon,
  Droplet: DropletIcon,
  Dumbbell: DumbbellIcon,
  GraduationCap: GraduationCapIcon,
  Hamburger: HamburgerIcon,
  Hospital: HospitalIcon,
  Hotel: HotelIcon,
  IceCreamCone: IceCreamConeIcon,
  Landmark: LandmarkIcon,
  LibraryBig: LibraryBigIcon,
  Pill: PillIcon,
  Search: SearchIcon,
  Scissors: ScissorsIcon,
  Shirt: ShirtIcon,
  ShoppingBasket: ShoppingBasketIcon,
  ShoppingCart: ShoppingCartIcon,
  Stethoscope: StethoscopeIcon,
  Square: SquareIcon,
  TrainFront: TrainFrontIcon,
  Trees: TreesIcon,
  Utensils: UtensilsIcon,
} as const;

export type SearchIconName = keyof typeof SEARCH_ICONS;
